import { render, staticRenderFns } from "./ModalAssinatura.vue?vue&type=template&id=5ffc377c&scoped=true&"
import script from "./ModalAssinatura.vue?vue&type=script&lang=js&"
export * from "./ModalAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssinatura.vue?vue&type=style&index=0&id=5ffc377c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc377c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VFlex,VIcon,VToolbar})
